import { createApi } from '@reduxjs/toolkit/query/react';
import { GraphQLClient } from 'graphql-request';
import { config } from 'lib-shared-backend-config';

import {
  CompanySettingsQuery,
  CompanySettingsQueryVariables,
} from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/data/types/dataHub.types';
import { elevioBaseQuery } from 'components/conversation/components/integrations/elevio/src/utils/apis/graphql/baseQuery';

import { elevioUrls } from '../../../../utils/apis';

import { companySettingsQuery } from './datahub.queries';

const datahubUrl =
  config.environment === 'prod'
    ? elevioUrls.production.datahub
    : elevioUrls.staging.datahub;

const datahubClient: GraphQLClient = new GraphQLClient(datahubUrl);

/** DataHub is a private Elevio API with limited read and write operations */
export const datahubApi = createApi({
  baseQuery: elevioBaseQuery(datahubClient),
  endpoints: (builder) => ({
    companySettings: builder.query<
      CompanySettingsQuery,
      CompanySettingsQueryVariables
    >({
      query: () => ({
        document: companySettingsQuery,
      }),
    }),
  }),
  reducerPath: 'elevioDatahubApi',
});
